// modules/website/components/PricingComponent.tsx

import React from 'react';
import { PricingData } from '@/types';
import { Check } from 'lucide-react';

interface Props {
  data: PricingData;
  settings: any;
}

export const PricingComponent: React.FC<Props> = ({ data, settings }) => {
  return (
    <div 
      className="py-20 px-6"
      style={{
        backgroundColor: settings.backgroundColor || '#ffffff',
      }}
    >
      <div className="max-w-7xl mx-auto">
        {data.title && (
          <h2 className="text-4xl font-bold text-center mb-12">
            {data.title}
          </h2>
        )}
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.plans.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-xl p-8 transition-all hover:scale-105 ${
                plan.highlighted ? 'ring-4 ring-blue-500 transform scale-105' : ''
              }`}
            >
              {plan.highlighted && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2">
                  <span className="bg-blue-500 text-white px-4 py-1 rounded-full text-sm font-semibold">
                    Mais Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold mb-4">{plan.name}</h3>
                <div className="flex items-baseline justify-center gap-2">
                  <span className="text-5xl font-bold">
                    R$ {plan.price.toLocaleString('pt-BR')}
                  </span>
                  <span className="text-gray-500">/{plan.period}</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start gap-3">
                    <Check className="text-green-500 flex-shrink-0 mt-1" size={20} />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href={plan.buttonUrl}
                className={`block w-full text-center px-6 py-4 rounded-lg font-semibold transition-all ${
                  plan.highlighted
                    ? 'bg-blue-600 text-white hover:bg-blue-700'
                    : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                }`}
              >
                {plan.buttonText}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
